import { graphql } from '@/generated/gql';

export const INTAKE_CHAT_THREAD_DETAILS = graphql(/* GraphQL */ `
  query IntakeChatThreadDetails($id: UUID!) {
    sevenbridges {
      thread(id: $id) {
        id
        metadata
        messages {
          id
          role
          content
          parts
          metadata
          createdAt
        }
      }
    }
  }
`);
